var exports = {
  "no": "VoiceSceneStageBoard.module__board___Y2x0Y2",
  "MT": "VoiceSceneStageBoard.module__surface___Y2x0Y2",
  "wx": "VoiceSceneStageBoard.module__header___Y2x0Y2",
  "Od": "VoiceSceneStageBoard.module__bot___Y2x0Y2",
  "ZN": "VoiceSceneStageBoard.module__botAvatar___Y2x0Y2",
  "hO": "VoiceSceneStageBoard.module__botName___Y2x0Y2",
  "DD": "VoiceSceneStageBoard.module__title___Y2x0Y2",
  "rf": "VoiceSceneStageBoard.module__body___Y2x0Y2",
  "Qq": "VoiceSceneStageBoard.module__text___Y2x0Y2",
  "so": "VoiceSceneStageBoard.module__scores___Y2x0Y2",
  "fN": "VoiceSceneStageBoard.module__score___Y2x0Y2",
  "KS": "VoiceSceneStageBoard.module__scoreAvatar___Y2x0Y2",
  "Kv": "VoiceSceneStageBoard.module__scoreName___Y2x0Y2",
  "Tm": "VoiceSceneStageBoard.module__rank___Y2x0Y2",
  "kE": "VoiceSceneStageBoard.module__scoreValue___Y2x0Y2",
  "Uo": "VoiceSceneStageBoard.module__buttons___Y2x0Y2",
  "x6": "VoiceSceneStageBoard.module__button___Y2x0Y2",
  "ZY": "VoiceSceneStageBoard.module__stageEnter___Y2x0Y2",
  "_S": "VoiceSceneStageBoard.module__sign___Y2x0Y2",
  "sd": "VoiceSceneStageBoard.module__signBoard___Y2x0Y2",
};

module.exports = exports;
